import { Injectable } from '@angular/core';
import { Usuario, Usuario2, Usuario3, UserOptions } from '../../models/usuario.model';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import Swal from 'sweetalert2';
import { map } from 'rxjs/operators';
import { Perfisica, PerMoral, ContribuyenteFisica, ContribuyenteMoral, DocumentoPropiedad } from '../../models/personas.model';
import 'rxjs/add/operator/map';
import { Router } from '@angular/router';


@Injectable()
export class DashboardService {

  usuario: Usuario;
  token: string;
  usuario2: Usuario2;
  idUsuario: string;

  constructor(
    public http: HttpClient,
    public router: Router
  ) {
  }


  getDatos() {

    const url = `${environment.URL_SERVICIOS}/reports/dashboard_admin`;

    return this.http.get(url).pipe(
      map( (resp: any) => {
        return resp;
      } )
    );

  }

  getAdminInvoices() {

    const url = `${environment.URL_SERVICIOS}/reports/dashboard_admin_invoices`;

    return this.http.get(url).pipe(
      map( (resp: any) => {
        return resp;
      } )
    );

  }

  getAdminRequests() {

    const url = `${environment.URL_SERVICIOS}/reports/dashboard_admin_requests`;

    return this.http.get(url).pipe(
      map( (resp: any) => {
        return resp;
      } )
    );

  }
// SOFOM ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  getAfiliadosTotales() {
    const url = `${environment.URL_SERVICIOS}/reports/dashboard_sofom_suppliers_for_company`;
    return this.http.get(url).pipe(
      map( (resp: any) => {
        return resp;
      } )
    );
  }
  getDispuestoInterescobrado() {
    const url = `${environment.URL_SERVICIOS}/reports/dashboard_sofom_interest_discounts_month`;
    return this.http.get(url).pipe(
      map( (resp: any) => {
        return resp;
      } )
    );
  }
  getFacturasvsDescuentos() {
    const url = `${environment.URL_SERVICIOS}/reports/dashboard_sofom_invoices_vs_discounts_month`;
    return this.http.get(url).pipe(
      map( (resp: any) => {
        return resp;
      } )
    );
  }
  getProveedoresAfiliados() {
    const url = `${environment.URL_SERVICIOS}/reports/dashboard_sofom_suppliers_movements`;
    return this.http.get(url).pipe(
      map( (resp: any) => {
        return resp;
      } )
    );
  }
  getAvgDiscountDays() {
    const url = `${environment.URL_SERVICIOS}/reports/dashboard_sofom_avg_discount_days_avg`;
    return this.http.get(url).pipe(
      map( (resp: any) => {
        return resp;
      } )
    );
  }

  getPagosyDisperciones() {
    const url = `${environment.URL_SERVICIOS}/reports/dashboard_sofom_payments_vs_discounts`;
    return this.http.get(url).pipe(
      map( (resp: any) => {
        return resp;
      } )
    );
  }

  getImpTotFacUlTresMeses() {
    const url = `${environment.URL_SERVICIOS}/dashboard/dashboard_admin`;
    return this.http.get(url).pipe(
      map( (resp: any) => {
        return resp;
      } )
    );
  }

  getImpTotFacNoDescXCad() {
    const url = `${environment.URL_SERVICIOS}/dashboard/total_invoices_pending`;
    return this.http.get(url).pipe(
      map( (resp: any) => {
        return resp;
      } )
    );
  }

  getImpTotOpxMesACur() {
    const url = `${environment.URL_SERVICIOS}/dashboard/total_month_operation_year`;
    return this.http.get(url).pipe(
      map( (resp: any) => {
        return resp;
      } )
    );
  }

  getImpTotOxFonYRecuProp() {
    const url = `${environment.URL_SERVICIOS}/dashboard/total_funders_operation_month`;
    return this.http.get(url).pipe(
      map( (resp: any) => {
        return resp;
      } )
    );
  }

  getTopTenProvXImpOpDivXMes() {
    const url = `${environment.URL_SERVICIOS}/dashboard/top_invoices_operation`;
    return this.http.get(url).pipe(
      map( (resp: any) => {
        return resp;
      } )
    );
  }

  getTopTenCadXImpOpDivXMes() {
    const url = `${environment.URL_SERVICIOS}/dashboard/top_companies_operation`;
    return this.http.get(url).pipe(
      map( (resp: any) => {
        return resp;
      } )
    );
  }

  getIntOpMes() {
    const url = `${environment.URL_SERVICIOS}/dashboard/total_interests_month`;
    return this.http.get(url).pipe(
      map( (resp: any) => {
        return resp;
      } )
    );
  }

  getImpTotCobCadXMes() {
    const url = `${environment.URL_SERVICIOS}/dashboard/total_require_companies_month`;
    return this.http.get(url).pipe(
      map( (resp: any) => {
        return resp;
      } )
    );
  }

  // 29/07/2026 - Consulta el reporte de proveedores extranjeros para el dashboard SOFOM (admin).
  // Devuelve un arreglo con cadena, proveedor extranjero, fechas y banderas de facturas subidas/operadas/pagadas.
  getForeignSuppliers() {
    const url = `${environment.URL_SERVICIOS}/reports/dashboard_admin_foreign_suppliers`;
    return this.http.get(url).pipe(
      map( (resp: any) => {
        return resp;
      } )
    );
  }

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// CADENA /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
getFacturasCanceladas(idc) {
  const url = `${environment.URL_SERVICIOS}/reports/company_id/${idc}/dashboard_company_invoices_ca`;
  return this.http.get(url).pipe(
    map( (resp: any) => {
      return resp;
    } )
  );
}
getProximosPagos(idc) {
  const url = `${environment.URL_SERVICIOS}/reports/company_id/${idc}/dashboard_company_next_payments`;
  return this.http.get(url).pipe(
    map( (resp: any) => {
      return resp;
    } )
  );
}
getFacturasdescontadasynodescontadas(idc) {
    const url = `${environment.URL_SERVICIOS}/reports/company_id/${idc}/dashboard_company_all_invoices`;
    return this.http.get(url).pipe(
      map( (resp: any) => {
        return resp;
      } )
    );
    }
getFacturasdescontadasproveedores(idc) {
      const url = `${environment.URL_SERVICIOS}/reports/company_id/${idc}/dashboard_company_invoices_vs_desc`;
      return this.http.get(url).pipe(
        map( (resp: any) => {
          return resp;
        } )
      );
      }
getFacturasCanceladasTotales(idc) {
        const url = `${environment.URL_SERVICIOS}/reports/company_id/${idc}/dashboard_company_cancel_invoices`;
        return this.http.get(url).pipe(
          map( (resp: any) => {
            return resp;
          } )
        );
        }
getComisionPagoSofom(idc) {
          const url = `${environment.URL_SERVICIOS}/reports/company_id/${idc}/dashboard_company_fees`;
          return this.http.get(url).pipe(
            map( (resp: any) => {
              return resp;
            } )
          );
          }
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// PROVEEDOR //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// 25/06/2026 - Se agrega user_id como query param para soporte multi_supplier
getFacturasNoDescontadas(idp, userId?) {
  let url = `${environment.URL_SERVICIOS}/reports/supplier_id/${idp}/dashboard_supplier_inv_to_expire_not_request`;
  if (userId) { url += `?user_id=${userId}`; }
  return this.http.get(url).pipe(
    map( (resp: any) => {
      return resp;
    } )
  );
  }
  getFacturasDescontadas(idp, userId?) {
    let url = `${environment.URL_SERVICIOS}/reports/supplier_id/${idp}/dashboard_supplier_inv_request`;
    if (userId) { url += `?user_id=${userId}`; }
    return this.http.get(url).pipe(
      map( (resp: any) => {
        return resp;
      } )
    );
    }
    getFacturasDescontadasMes(idp, userId?) {
      let url = `${environment.URL_SERVICIOS}/reports/supplier_id/${idp}/dashboard_supplier_used_int_rate_month`;
      if (userId) { url += `?user_id=${userId}`; }
      return this.http.get(url).pipe(
        map( (resp: any) => {
          return resp;
        } )
      );
      }
      getImporteFacturas(idp, userId?) {
        let url = `${environment.URL_SERVICIOS}/reports/supplier_id/${idp}/dashboard_supplier_used_int`;
        if (userId) { url += `?user_id=${userId}`; }
        return this.http.get(url).pipe(
          map( (resp: any) => {
            return resp;
          } )
        );
        }
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

///// VALIDACIONES /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

getUserType(idu) {
  const url = `${environment.URL_SERVICIOS}/reports/user_id/${idu}/user_type`;
  return this.http.get(url).pipe(
    map( (resp: any) => {
      return resp;
    } )
  );
}

delinquencyIndicatorAdmin() {
  const url = `${environment.URL_SERVICIOS}/reports/delinquency_indicator`;
  return this.http.get(url).pipe(
    map( (resp: any) => {
      return resp;
    } )
  );
}

delinquencyIndicator(company_id) {
  const url = `${environment.URL_SERVICIOS}/reports/delinquency_indicator?company_id=${company_id}`; //PROBAR
  return this.http.get(url).pipe(
    map( (resp: any) => {
      return resp;
    } )
  );
}

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

//BANCOPPEL DASHBOARD/////
getSolFonHisEssol() {
  const url = `${environment.URL_SERVICIOS}/reports/dashboard_bancoppel_funding_request_history`;
  return this.http.get(url).pipe(
    map( (resp: any) => {
      return resp;
    } )
  );
}

getSolFonHisEsDifsol() {
  const url = `${environment.URL_SERVICIOS}/reports/dashboard_bancoppel_funding_history`;
  return this.http.get(url).pipe(
    map( (resp: any) => {
      return resp;
    } )
  );
}

getClientesxCadena() {
  const url = `${environment.URL_SERVICIOS}/reports/dashboard_bancoppel_credit_lines`;
  return this.http.get(url).pipe(
    map( (resp: any) => {
      return resp;
    } )
  );
}
//////////////////////////

getReporteFactXCompany(cid) {
  const url = `${environment.URL_SERVICIOS}/reports/general_report_invoices_by_company?company_id=${cid}`;
  return this.http.get(url).pipe(
    map( (resp: any) => {
      return resp;
    } )
  );

}

getCompanyInfo(cid) {
  const url = `${environment.URL_SERVICIOS}/company_report/${cid}`;
  return this.http.get(url).pipe(
    map( (resp: any) => {
      return resp;
    } )
  );

}

getSupplierInfo(sid) {
  const url = `${environment.URL_SERVICIOS}/supplier_report/${sid}`;
  return this.http.get(url).pipe(
    map( (resp: any) => {
      return resp;
    } )
  );

}

}
